// removed by extract-text-webpack-plugin
module.exports = {"right":"src-components-Message__right__3sjpZ","userName":"src-components-Message__userName__28R8J","textContainer":"src-components-Message__textContainer__1zoJo","text":"src-components-Message__text__3pL2r","createdAt":"src-components-Message__createdAt__25uRQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Message.css
// module id = 362
// module chunks = 0